import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=67f35fdc&scoped=true&"
import script from "./MessageAlert.vue?vue&type=script&lang=ts&"
export * from "./MessageAlert.vue?vue&type=script&lang=ts&"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=67f35fdc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f35fdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
